<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${serviceSlug}`), disabled: true },
        { title: $t('clinical.call_ratings.title'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch" />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>
    </Breadcrumbs>

    <RequestRatingsTable
      ref="tableView"
      :service="component.service"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      :customQueries="customQueries"
      @filters-updated="onFiltersUpdated"
      @row-clicked="onRowClicked"
    />

    <RequestRatingsDetailModal
      v-if="showRequestRatingModal"
      :request="request"
      @modalClosed="onCallRatingModalCanceled"
    />

  </div>
</template>
<script>
import Filters from '@/components/common/Filters'
import Searchable from '@/components/common/Searchable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import { TABLE_CLINICAL_CALL_RATINGS } from '@/local-storage/LocalStorageKeys'
import RequestRatingsTable from '@/components/virtual_waiting_room/requests_ratings/RequestRatingsTable'
import RequestRatingsDetailModal from '@/components/virtual_waiting_room/requests_ratings/RequestRatingDetailsModal'

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  mixins: [
    IndexTablesMixin
  ],
  components: {
    RequestRatingsDetailModal,
    RequestRatingsTable,
    Filters,
    Searchable,
    Breadcrumbs
  },
  data () {
    return {
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_CLINICAL_CALL_RATINGS,
      request: null,
      showRequestRatingModal: false,
      customQueries: null
    }
  },
  methods: {
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
      if (activeFilters > 0) {
        this.showFilters = true
      }
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    onRowClicked: function ({ request }) {
      this.request = request
      this.showRequestRatingModal = true
    },
    onCallRatingModalCanceled: function () {
      this.showRequestRatingModal = false
      this.request = null
    }
  }
}
</script>
